module.exports = __webpack_public_path__ + "static/media/downArrowBlack.d54e7c62.svg";